import {
  inboundShipmentIdFormat,
  productIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const ShipmentProductAssignmentSchema_ = z.object({
  shipmentId: inboundShipmentIdFormat.schema,
  productId: productIdFormat.schema,
  quantity: z.number().int(),
});

export const ShipmentProductAssignmentSchema: z.ZodType<ShipmentProductAssignment> =
  ShipmentProductAssignmentSchema_;
export interface ShipmentProductAssignment
  extends z.infer<typeof ShipmentProductAssignmentSchema_> {}

export const updateShipmentProducts = {
  name: "updateShipmentProducts" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    assignments: z.array(ShipmentProductAssignmentSchema),
  }),
  output: z.object({ success: z.boolean() }),
};
